import Tooltip from "./Tooltip";
import { CircleActionButton } from "./CircleButton";

export const CompactActionButton: React.FC<{
  $tooltipContent: string;
  $active?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
}> = ({ $tooltipContent, $active, onClick, children }) => {
  return (
    <Tooltip content={$tooltipContent} position="top">
      <CircleActionButton $active={$active} onClick={onClick}>
        {children}
      </CircleActionButton>
    </Tooltip>
  );
};
